import {useEffect, useRef, useState} from "react";
import {InventoryService} from "./Service";
import {UploadService} from "../../utils/UploadService";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Select from "react-select";
import {SettingService} from "../setting/Service";
import {nanoid} from 'nanoid'
import {toast} from "react-hot-toast";
import {useParams} from "react-router-dom";
import JsBarcode from 'jsbarcode';
import VariantManagement from "../variant/VariantManagement";


const UpdateProduct = () => {
    const {id} = useParams();
    const service = new InventoryService();
    const uploadService = new UploadService();
    const settingService = new SettingService();
    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [description, setDescription] = useState('');
    const [purchasePrice, setPurchasePrice] = useState(0);
    const [salePrice, setSalePrice] = useState(0);
    const [quantity, setQuantity] = useState(0);
    const [hsn, setHsn] = useState('');
    const [discount, setDiscount] = useState(0);
    const [minQuantity, setMinQuantity] = useState(0);
    const [category, setCategory] = useState<{ label: string, value: string } | null>(null);
    const [unit, setUnit] = useState<{ label: string, value: string } | null>(null);
    const [tax, setTax] = useState<{ label: string, value: string } | null>(null);
    const [categoryOptions, setCategoryOptions] = useState<{ label: string, value: string }[]>([]);
    const [unitOptions, setUnitOptions] = useState<{ label: string, value: string }[]>([]);
    const [taxTypeOptions, setTaxTypeOptions] = useState<{ label: string, value: string }[]>([]);
    const [attributeOptions, setAttributeOptions] = useState<{ label: string, value: string|null, id: number }[]>([]);

    // File Upload
    const [selectedfile, SetSelectedFile] = useState([]);
    const [Files, SetFiles] = useState([]);

    const filesizes = (bytes: any, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    const InputChange = (e: any) => {
        // --For Multiple File Input
        let images = [];
        for (let i = 0; i < e.target.files.length; i++) {
            images.push((e.target.files[i]));
            let reader = new FileReader();
            let file = e.target.files[i];
            reader.onloadend = () => {
                // @ts-ignore
                SetSelectedFile((preValue: any) => {
                    return [
                        ...preValue,
                        {
                            id: nanoid(),
                            filename: e.target.files[i].name,
                            filetype: e.target.files[i].type,
                            fileimage: reader.result,
                            datetime: e.target.files[i].lastModifiedDate.toLocaleString('en-IN'),
                            filesize: filesizes(e.target.files[i].size),
                            file: file
                        }
                    ]
                });
            }
            if (e.target.files[i]) {
                reader.readAsDataURL(file);
            }
        }
    }


    const DeleteSelectFile = (id: any) => {
        if (window.confirm("Are you sure you want to delete this Image?")) {
            const result = selectedfile.filter((data: any) => data.id !== id);
            SetSelectedFile(result);
        } else {
            // alert('No');
        }

    }


    const DeleteFile = async (id: any) => {
        if (window.confirm("Are you sure you want to delete this Image?")) {
            toast.loading('Deleting image...');
            const res = await service.deleteProductImage(id);
            toast.dismiss();
            if (res) {
                toast.success('Image deleted successfully');
                const result = Files.filter((data: any) => data.id !== id);
                SetFiles(result);
            }
        } else {
            // alert('No');
        }
    }


    useEffect(() => {
        const getCategories = async () => {
            const res = await service.allCategories();
            if (res) {
                const options = res.map((item: any) => {
                    return {
                        label: item.name,
                        value: item.id
                    }
                });
                setCategoryOptions(options);
            }
        }
        getCategories();
    }, [])

    useEffect(() => {
        const getUnits = async () => {
            const res = await service.allUnits();
            if (res) {
                const options = res.map((item: any) => {
                    return {
                        label: `${item.name} (${item.symbol})`,
                        value: item.id
                    }
                });
                setUnitOptions(options);
            }
        }
        getUnits();
    }, [])



    useEffect(() => {
        const getProduct = async () => {
            const res = await service.getProduct(parseInt(id!));
            if (res) {
                setName(res.name);
                setCode(res.code);
                setDescription(res.description);
                setPurchasePrice(res.purchasePrice);
                setSalePrice(res.salePrice);
                setQuantity(res.quantity);
                setHsn(res.hsn);
                setDiscount(res.discount);
                setMinQuantity(res.minQuantity);
                if (res.category) {
                    setCategory({
                        label: res.category.name,
                        value: res.category.id
                    });
                }
                if (res.unit) {
                    setUnit({
                        label: `${res.unit.name} (${res.unit.symbol})`,
                        value: res.unit.id
                    });
                }
                if (res.tax) {
                    setTax({
                        label: `${res.tax.name} (${res.tax.percentage}%)`,
                        value: res.tax.id
                    });
                }
                const images = res.images.map((item: any) => {
                    return {
                        id: item.id,
                        filename: item.image.split('/')[item.image.split('/').length - 1].split('.')[0] + '.webp',
                        filetype: 'webp',
                        fileimage: item.image,
                        datetime: item.createdAt,
                        filesize: '',
                        file: null
                    }
                });
                SetFiles(images);
            }
        }
        getProduct();
    }, []);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        toast.loading('Updating product...');
        const images = [];
        for (let i = 0; i < selectedfile.length; i++) {
            const res = await uploadImage((selectedfile[i] as any).file);
            if (res) {
                images.push(res);
            }
        }
        const data = {
            name: name,
            code: code,
            description: description,
            purchasePrice: purchasePrice,
            salePrice: salePrice ? salePrice : 0,
            quantity: quantity,
            hsn: hsn,
            discount: discount,
            minQuantity: minQuantity,
            category: category ? parseInt(category.value) : null,
            unit: unit ? parseInt(unit.value) : null,
            tax: tax ? parseInt(tax.value) : null,
            images: images,
        }
        const res = await service.updateProduct(parseInt(id!), data);
        if (res) {
            toast.success('Product updated successfully');
        }
    }

    const uploadImage = async (file: any) => {
        const res = await uploadService.upload(file);
        return res.length > 0 ? res[0] : null;
    }

    useEffect(() => {
        const getTaxTypes = async () => {
            const res = await settingService.allTaxTypes();
            if (res) {
                const options = res.map((item: any) => {
                    return {
                        label: `${item.name} (${item.percentage}%)`,
                        value: item.id
                    }
                });
                setTaxTypeOptions(options);
            }
        }
        getTaxTypes();
    }, [])

    const downloadBarcode = () => {
        JsBarcode("#barcode", code, {
            format: "CODE128",
            width: 3,
            displayValue: true,
            text: code
        });
        const canvas = document.querySelector('canvas');
        console.log(canvas)
        if (canvas) {
            const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
            const link = document.createElement('a');
            link.setAttribute('download', 'barcode.png');
            link.setAttribute('href', image);
            link.click();
        }
    };

    return (
        <>
            <div className="page-header">
                <div className="content-page-header ">
                    <h5>Update Product </h5>
                    <div className="list-btn">
                        <ul className="filter-list">
                            <li>
                                <a
                                    className="btn btn-primary"
                                    href="javascript:void(0);"
                                    onClick={downloadBarcode}
                                >
                                    <i className="fa fa-barcode me-2" aria-hidden="true"/>
                                    Download Barcode
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="card mb-0">
                <div className="card-body">
                    <form onSubmit={handleSubmit} className="row">
                        <div className="col-12 d-none">
                            <div className="input-block mb-3">
                                <label>Product Barcode <span className="text-danger">(required)</span></label>
                                <div>
                                    <canvas id="barcode"></canvas>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                                <label>Product Name <span className="text-danger">(required)</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter product name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                                <label>Product Code <span className="text-danger">(required)</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter product code"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>

                        {/*<div className="col-lg-4 col-12 mb-3">*/}
                        {/*    <label htmlFor="tax" className="form-label">Tax</label>*/}
                        {/*    <Select*/}
                        {/*        name="tax"*/}
                        {/*        options={taxTypeOptions}*/}
                        {/*        value={tax}*/}
                        {/*        menuPortalTarget={document.body}*/}
                        {/*        styles={{*/}
                        {/*            menuPortal: base => ({*/}
                        {/*                ...base,*/}
                        {/*                zIndex: 9999*/}
                        {/*            })*/}
                        {/*        }}*/}
                        {/*        onChange={setTax}/>*/}
                        {/*</div>*/}

                        <div className="col-lg-12">
                            <div className="btn-path text-end">
                                <a
                                    href="javascript:void(0);"
                                    className="btn btn-cancel bg-primary-light me-3"
                                    onClick={() => {
                                        window.history.back();
                                    }}
                                >
                                    Back
                                </a>
                                <button type="submit" className="btn btn-primary">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div className='mt-5 p-3'>
                <VariantManagement product={id!}/>
            </div>
        </>
    );
}

export default UpdateProduct;